window.WpGvr = window.WpGvr || {};

(function($){
	var WpGvr = window.WpGvr;

	var segment = new Object();

	WpGvr.setCat = function(catId) {
		var catChooser = document.getElementById(catId);

		// alle huidige opties er uit
		while (catChooser.options.length) {
			catChooser.remove(0);
		}
		var choice = 'list';
		var segm = segment[choice];

		// nieuwe opties erin
		if (choice != "") {
			for (var i = 0; i < segm.length; i++) {
				newElem = document.createElement("option");
				newElem.text = segm[i].text;
				newElem.value = segm[i].value;
				catChooser.add(newElem);
			}
		}
	};

	WpGvr.setFunc = function( segmChooser, funcId ) {
		if( undefined == funcId ) {
			funcId = segmChooser.id.replace('segment', 'functie');
		}

		var funcChooser = document.getElementById(funcId);
		if ( ! funcChooser ) {
			return;
		}

		// alle huidige opties er uit
		while ( funcChooser.options.length ) {
			funcChooser.remove(0);
		}

		var choice = '';
		if( segmChooser.selectedIndex >= 0 )
			choice = segmChooser.options[segmChooser.selectedIndex].value;

		if ( choice && Number.isInteger( choice ) ) {
			// probeer het segment object te vullen
			if( segment[choice] == undefined ) {
				segment[choice] = laad_functies( choice, segment, segmChooser, funcId );
			} else {
				_setFunc( segmChooser, funcId, choice );
			}
		} else {
			_setFunc( segmChooser, funcId, '' );
		}
	};

	WpGvr.functies = function ( segmentID, callback ) {
		if ( segmentID && Number.isInteger( segmentID ) ) {
			$.getJSON(
				WpGvr.ajaxurl,
				{
					action: 'wp_gvr_functies',
					segmentid: segmentID
				},
				callback
			);
		} else {
			callback( { success: false } );
		}
	};

	var _setFunc = function( segmChooser, funcId, choice ) {
		var funcChooser = document.getElementById(funcId);
		var segm = [];
		if ( ! funcChooser ) {
			return;
		}

		if( ! choice || segment[choice] == undefined ) {
			segm = [{ 'naam':'Selecteer eerst een vakgebied', 'id':'' }];
		} else {
			if( !funcChooser.multiple ) // add empty option for drop-down menu's
				segm.push({ 'naam': 'Selecteer een functie', 'id': '' });

			segm = segm.concat(segment[choice]);
		}

		// nieuwe opties erin
		for (var i in segm) {
			newElem = document.createElement("option");
			newElem.text = segm[i].naam;
			newElem.value = segm[i].id;
			funcChooser.add(newElem);
		}
	};

	var laad_functies = function( segmentID, segment, segmChooser, funcId ) {
		$.post(
			WpGvr.ajaxurl,
			{
				// wp action
				action : 'wp_gvr_laad_functies',
	
				// other parameters can be added along with "action"
				segmentID : segmentID
			},
			function( response ) {
				if( typeof(response) == 'object' )
					segment[segmentID] = response;
				_setFunc( segmChooser,funcId, segmentID );
			},
			'json'
		);
	};
}(jQuery));
